import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { BaseUrl } from "../common/config";
import discountIcon from "../assets/images/discount-icon.png";
import carboIcon from "../../components/assets/images/promo-flag-icon.png";
import promoIcon from "../../components/assets/images/free-offer-box-icon.png";
import { http } from "../helper";
import DataTable from "react-data-table-component";
import Sidebar from "../common/sidebar";
import moment from "moment";
import CommonAlert from "../common/Commonalert";
import Popup from "../common/popup";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { dateformatwithuktime } from "../utilityfunctions";
import * as XLSX from "sheetjs-style";
import { saveAs } from "file-saver";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";

const CUSTOM_TABLE_STYLES = {
  rows: {
    style: {
      minHeight: "25px",
    },
  },
  headCells: {
    style: {
      padding: "8px", // override the cell padding for head cells
    },
  },
  cells: {
    style: {
      padding: "8px", // override the cell padding for data cells
    },
  },
};

const PAGINATION_COMPONENT_OPTIONS = {
  rowsPerPageText: "",
  rangeSeparatorText: "",
  selectAllRowsItem: true,
  selectAllRowsItemText: "",
  noRowsPerPage: "",
};

const Orders = () => {
  const { t } = useTranslation();
  const INITIAL_STATE = {
    orders: [],
    temporders: [],
    priceBands: [],
    searchTextVal: "",
    loading: true,
    popupView: "",
    alertMessage: "",
    alertPopup: false,
    isElementVisible: false,
    datelabel: t("past_30_days_txt"),
    datefilterlabel: t("past_30_days_txt"),
    dateRange: 30,
    datepickershow: false,
    datefrom: "",
    dateto: "",
    datefromLabel: "",
    datetoLabel: "",
    dateinvalid_error: false,
    datefill_error: false,
    searchstate: false,
    searchField: "OrderNumber",
    searchFieldtxt: t("order_number_txt"),
    notesPopup: false,
    note: "",
    currentOrder: [],
    orderlogs: [],
    noteError: false,
    isLoading: false,
    uploadMessage: "",
    showPopup: false,
    trigerDateFilter: false,
    isFilterApplied: false,
    selectedDateOption: { value: "1", label: t("past_30_days_txt") },
    mainDepotList: [],
    subDepotList: [],
    restrictedAccounts: [],
    rangeOptions: [
      { value: "1", label: t("past_30_days_txt") },
      { value: "3", label: t("past_90_days_txt") },
      { value: "6", label: t("past_180_days_txt") },
      { value: "1Year", label: t("past_1_year_txt") },
      { value: "custom", label: t("custom_txt") },
    ],
    visibleAlert: false,
    visibleNoDataAlert: false,
    sectorList: [],
    dateFilterType: "orderDate",
    tempDateFilterType: "orderDate",
    tempFavouriteOrders: [],
    suggestions: [],
  };
  const [state, setStateRaw] = useState(INITIAL_STATE);
  const stateRef = useRef(INITIAL_STATE);
  const setState = useCallback((updater) => {
    setStateRaw((prev) => {
      const partial = typeof updater === "function" ? updater(prev) : updater;
      const next = { ...prev, ...partial };
      stateRef.current = next;
      return next;
    });
  }, []);

  const searchFieldRef = useRef(null);
  const searchInputRef = useRef(null);
  const dropdownRef = useRef(null);

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_orders")
  ) {
    window.location.href = "/unauthorized";
  }

  const handleClickOutside = (event) => {
    if (dropdownRef && !dropdownRef.current.contains(event.target)) {
      setState({ isElementVisible: false });
    }
  };

  const openFilter = () => {
    setState((prevState) => ({
      isElementVisible: !prevState.isElementVisible,
    }));
    clearforOpenFilter();
  };

  const fetchSectors = () => {
    let URL = BaseUrl + "admin/product/masterentries/sectors";
    http
      .get(URL)
      .then((res) => {
        if (res.data.success) {
          setState({ sectorList: res.data.data });
        }
      })
      .catch((err) => console.log(err));
  };

  function getAllOrders() {
    var dateval = "";
    var dateval2 = "";
    if (stateRef.current.datefrom && stateRef.current.dateto) {
      dateval = stateRef.current.datefrom
        ? new Date(stateRef.current.datefrom)
        : "";
      dateval = format(dateval, "yyyy-MM-dd");
      dateval2 = new Date(stateRef.current.dateto);
      dateval2 = format(dateval2, "yyyy-MM-dd");
    }
    let payload = {
      orderdays:
        stateRef.current.dateRange &&
        typeof stateRef.current.dateRange === "number"
          ? stateRef.current.dateRange
          : stateRef.current.dateRange &&
              typeof stateRef.current.dateRange === "string"
            ? ""
            : 30,
      datefrom: dateval ? dateval : "",
      dateto: dateval2 ? dateval2 : "",
      from: "backend",
      filterType: stateRef.current.dateFilterType,
    };
    let URL = BaseUrl + "admin/orders";
    if (sessionStorage.getItem("authData")) {
      var loginemail = JSON.parse(
        sessionStorage.getItem("authData"),
      ).adminEmail;
    }
    http
      .post(URL, payload)
      .then((response) => {
        let responseData = [];
        const { restrictedAccounts } = stateRef.current;
        if (loginemail === "karthik@k2bsolutions.in") {
          responseData = response.data.data;
        } else {
          responseData = response.data.data.filter(
            (order) => !restrictedAccounts.includes(order.accountCode),
          );
        }
        setState({
          orders: responseData,
          loading: false,
          temporders: responseData,
          alertPopup: false,
          alertMessage: "",
          searchstate: false,
          searchField: "",
          searchFieldtxt: t("order_number_txt"),
          searchTextVal: "",
        });
        var element = document.querySelectorAll(".fa-refresh");
        element.forEach((row) => {
          row.classList.remove("fa-spin");
        });
      })
      .catch((err) => {
        var element = document.querySelectorAll(".fa-refresh");
        element.forEach((row) => {
          row.classList.remove("fa-spin");
        });
        setState({
          alertPopup: true,
          loading: false,
          alertMessage: t("server_busy_txt"),
        });
      });
    let URL1 = BaseUrl + `admin/getdepots`;
    http
      .get(URL1)
      .then((response) => {
        let responseData = response.data.data;
        const uniqueDepots = Array.from(
          new Set(responseData.map((item) => item.mainDepot)),
        ).map((mainDepot) =>
          responseData.find((item) => item.mainDepot === mainDepot),
        );
        setState({ subDepotList: responseData });
        setState({ mainDepotList: uniqueDepots });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getPriceBands() {
    let URL = BaseUrl + "admin/pricebands";
    if (sessionStorage.getItem("authData")) {
      var loginemail = JSON.parse(
        sessionStorage.getItem("authData"),
      ).adminEmail;
    }
    http
      .get(URL)
      .then(async (response) => {
        console.log(response);
        let responseData = [];
        responseData = response.data.data;
        setState({ priceBands: responseData });
      })
      .catch((error) => {
        console.error("Error updating customer status:", error);
      });
  }

  function priceFormat(price) {
    if (price == null || isNaN(price)) {
      return t("price_placeholder_txt");
    }
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  }

  function vatAmountCalcuation(order) {
    var totalAmount = 0;
    order.items.map((item, value) => {
      if (item.TaxCode !== "" && item.TaxCode === "T1") {
        totalAmount += item.LinePrice;
      }
    });
    return totalAmount;
  }

  const getOrderaccountdetails = useCallback((accountCode, orderrow) => {
    setState({
      popupView: (
        <Popup
          extClass="order-pop"
          headMoreTxt={
            <>
              <div className="order-top">
                <div className="bottom order-flex">
                  {/* Changed for getting account details of particular order  */}
                  <div className="order_no_details">
                    <h3>{t("order_no_txt")} - {orderrow.OrderNumber}</h3>
                    <p>
                      {t("order_placed_on_txt")}:{" "}
                      <span className="date">
                        {" "}
                        {moment(orderrow.createdAt).format(
                          "DD/MM/YYYY hh:mm A",
                        )}
                      </span>{" "}
                    </p>
                    <p>
                      {t("order_deleivery_on_txt")}:{" "}
                      <span className="date"> {orderrow.DateRequired} </span>
                    </p>
                    {orderrow.PaymentMethod === "A" && (
                      <p>
                        {t("payment_method_txt")}:
                        <span className="pay">
                          {" "}
                          {orderrow.OrderPaid === "YES"
                            ? t("paid_pay_later_txt")
                            : t("pay_later_txt")}
                        </span>
                      </p>
                    )}
                    {orderrow.PaymentMethod === "K" && (
                      <p>
                        {t("payment_method_txt")}:
                        <span className="pay">{t("online_payment_txt")}</span>
                      </p>
                    )}
                    <p>
                      {t("status_txt")}:
                      <span className="pay"> {orderrow.OrderStatus}</span>
                    </p>
                    {/* Only show placedBy if it exists */}
                    {orderrow.placedBy &&
                      orderrow.placedBy !== orderrow.accountCode && (
                        <p>
                          {t("order_placed_by_txt")}:{" "}
                          <span className="pay">{orderrow.placedBy}</span>{" "}
                        </p>
                      )}
                  </div>
                  <div className="order_account_details">
                    <p>
                      {t("name_txt")}:{" "}
                      <span className="date">{orderrow.accountName}</span>{" "}
                    </p>
                    <p>
                      {t("account_code_txt")}:{" "}
                      <span className="date">{orderrow.accountCode}</span>{" "}
                    </p>
                    <p>
                      {t("email_address_txt")}:{" "}
                      <span className="pay">{orderrow.accountEmail}</span>
                    </p>
                    <p>
                      {t("address_txt")}:{" "}
                      <span className="pay">{orderrow.accountAddress}</span>
                    </p>
                    {orderrow.PODetails && (
                      <p>
                        {t("po_details_txt")}:{" "}
                        <span className="pay">{orderrow.PODetails}</span>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
          }
          closebtn={
            <>
              <div className="order-top">
                <div className="head">
                  <h4>{t("order_details_txt")} - {orderrow.OrderNumber}</h4>
                </div>
                <span
                  onClick={() => setState({ popupView: "" })}
                  className="close"
                ></span>
              </div>
            </>
          }
          bodyMoreTxt={
            <div className="modal-table">
              <h4 className="item-title">{t("ordered_items_txt")}</h4>
              <div className="checkout-table">
                <div className="table_overflow">
                  <table>
                    <tbody>
                      <tr>
                        <td colspan={5} className="is-loading">
                          <div>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
        />
      ),
      alertPopup: false,
      loading: true,
    });
    let URL =
      BaseUrl +
      "admin/updateorderitems/" +
      accountCode +
      "/" +
      orderrow.OrderNumber;
    http
      .get(URL)
      .then((response) => {
        let responseData = [];
        responseData = response.data.data[0];
        setState({ loading: false });
        viewOrderDetails(responseData);
      })
      .catch((err) => {
        setState({ loading: false });
      });
  }, []);

  const closePopup = () => {
    setState({ showPopup: false, uploadMessage: "" });
  };

  const orderRecordsTotal = (orders) => {
    let totalOrderAmount = 0;
    let orderCount = 0;
    orders.forEach((order) => {
      orderCount++;
      if (stateRef.current.searchTextVal.toLowerCase() === "orders placed") {
        if (order.OrderStatus !== "Cancelled") {
          totalOrderAmount +=
            order.OrderTotalWithVat !== undefined ? order.OrderTotalWithVat : 0;
        }
      } else if (
        stateRef.current.searchFieldtxt === t("order_status_txt") &&
        stateRef.current.searchTextVal === "Cancelled"
      ) {
        totalOrderAmount +=
          order.OrderTotalWithVat !== undefined ? order.OrderTotalWithVat : 0;
      } else if (order.OrderStatus !== "Cancelled") {
        totalOrderAmount +=
          order.OrderTotalWithVat !== undefined ? order.OrderTotalWithVat : 0;
      }
      if (order.OrderTotalWithVat === undefined) {
        console.log(order);
      }
    });
    return {
      totalOrderAmount: priceFormat(totalOrderAmount),
      totalOrderCount: orderCount,
    };
  };

  function viewOrderDetails(order) {
    var ordertotal = 0;
    var subTotal = 0;
    setState({ alertPopup: false, alertMessage: "" });
    // Sort order items to move those with UnitPrice 0 to the end
    const sortedItems = [...order.items].sort((a, b) => {
      if (a.UnitPrice === 0 && b.UnitPrice !== 0) return 1;
      if (a.UnitPrice !== 0 && b.UnitPrice === 0) return -1;
      if (a.ProductNumber === "77775" && b.ProductNumber !== "77775") return 1;
      if (b.ProductNumber === "77775" && a.ProductNumber !== "77775") return -1;
      return 0;
    });
    sortedItems.map((item) => {
      ordertotal += item.LinePrice;
    });
    sortedItems.map((item) => {
      subTotal += item.UnitPrice * item.QuantityOrdered;
    });
    var vatTotalAmount = vatAmountCalcuation(order);
    var vatAmount = 0;
    if (vatTotalAmount > 0) {
      vatAmount = (vatTotalAmount / 100) * 20;
      ordertotal = ordertotal + vatAmount;
    }
    let popupResult = (
      <Popup
        extClass="order-pop my-order-details-pop"
        headMoreTxt={
          <>
            <div className="order-top">
              <div className="bottom order-flex">
                {/* Changed for getting account details of particular order  */}
                <div className="order_no_details">
                  <h3>{t("order_no_txt")} - {order.OrderNumber}</h3>
                  <p>
                    {t("order_placed_on_txt")}:{" "}
                    <span className="date">
                      {" "}
                      {moment(order.createdAt).format("DD/MM/YYYY hh:mm A")}
                    </span>{" "}
                  </p>
                  <p>
                    {t("order_deleivery_on_txt")}:{" "}
                    <span className="date"> {order.DateRequired} </span>
                  </p>
                  {order.PaymentMethod === "A" && (
                    <p>
                      {t("payment_method_txt")}:
                      <span className="pay">
                        {" "}
                        {order.OrderPaid === "YES"
                          ? t("paid_pay_later_txt")
                          : t("pay_later_txt")}
                      </span>
                    </p>
                  )}
                  {order.PaymentMethod === "K" && (
                    <p>
                      {t("payment_method_txt")}:
                      <span className="pay">{t("online_payment_txt")}</span>
                    </p>
                  )}
                  <p>
                    {t("status_txt")}:<span className="pay"> {order.OrderStatus}</span>
                  </p>
                  {/* Only show placedBy if it exists */}
                  {order.placedBy && order.placedBy != order.accountCode && (
                    <p>
                      {t("order_placed_by_txt")}:{" "}
                      <span className="pay">{order.placedBy} </span>{" "}
                    </p>
                  )}
                </div>
                <div className="order_account_details">
                  <p>
                    {t("name_txt")}: <span className="date">{order.accountName}</span>{" "}
                  </p>
                  <p>
                    {t("account_code_txt")}:{" "}
                    <span className="date">{order.accountCode}</span>{" "}
                  </p>
                  <p>
                    {t("email_address_txt")}:{" "}
                    <span className="pay">{order.accountEmail}</span>
                  </p>
                  <p>
                    {t("address_txt")}: <span className="pay">{order.accountAddress}</span>
                  </p>
                  {order.PODetails && (
                    <p>
                      {t("po_details_txt")}: <span className="pay">{order.PODetails}</span>
                    </p>
                  )}
                  <p>
                    {t("price_band_txt")}:{" "}
                    <span className="date">{order.Priceband}</span>{" "}
                  </p>
                </div>
                {/* Changed for getting account details of particular order  */}
              </div>
            </div>
          </>
        }
        closebtn={
          <>
            <div className="pop-header-top order-top">
              <div className="head">
                <h4>{t("order_details_txt")} - {order.OrderNumber}</h4>
              </div>
              <span
                onClick={() => setState({ popupView: "" })}
                className="close"
              ></span>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="modal-table">
              <h4 className="item-title">{t("ordered_items_txt")}</h4>
              <div className="checkout-table">
                <div className="table_overflow">
                  <table>
                    <thead>
                      <tr>
                        <td>{t("product_txt")}</td>
                        <td>{t("unit_of_sale_txt")}</td>
                        <td>{t("quantity_txt")}</td>
                        <td align="center">{t("price_txt")}</td>
                        <td align="right">{t("total_txt")}</td>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Added Special offer and product number like frontend by k2b Sangeetha   */}
                      {sortedItems.map((item, index) => {
                        return (
                          item.QuantityOrdered > 0 && (
                            <tr
                              key={index}
                              className={
                                item.UnitPrice === 0 ||
                                item.ProductNumber === "77775"
                                  ? "free-prod-bg"
                                  : ""
                              }
                            >
                              <td
                                data-title={t("product_txt")}
                                className="data-product-hide"
                              >
                                {str_replace(item.Description)} (
                                {item.ProductNumber.includes("_")
                                  ? item.ProductNumber.substring(
                                      0,
                                      item.ProductNumber.indexOf("_"),
                                    )
                                  : item.ProductNumber}
                                )
                                {item.TaxCode !== "" &&
                                  item.TaxCode === "T1" && (
                                    <span className="color-red">*</span>
                                  )}
                                {item.OfferFlag == "true" &&
                                  item.UnitPrice > 0 && (
                                    <span className="offer-tag-wrap">
                                      <span className="offer-tag">
                                        <img
                                          src={discountIcon}
                                          alt="Offer"
                                          className="tag-icon"
                                        />
                                        {t("special_offer_txt")}
                                      </span>
                                    </span>
                                  )}
                              </td>
                              <td data-title={t("unit_of_sale_txt")}>
                                {item.PricingUnit}
                              </td>
                              <td data-title={t("quantity_txt")}>
                                {item.QuantityOrdered}
                              </td>
                              <td data-title={t("price_txt")} align="center">
                                {priceFormat(item.UnitPrice)}
                              </td>
                              <td data-title={t("total_txt")} align="right">
                                {priceFormat(item.LinePrice)}
                              </td>
                            </tr>
                          )
                        );
                      })}
                      {/* Added Special offer and product number like frontend by k2b Sangeetha   */}
                    </tbody>
                    <thead className="ord-grand-total">
                      {order.OrderNote !== "" && order.OrderNote !== null && (
                        <tr>
                          <td align="left" width={120} colSpan="7">
                            {t("order_notes_txt")}:{" "}
                            <span className="order_remarks">
                              {" "}
                              {getOrderNotes(order.OrderNote)}
                            </span>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td align="right" width={120} colSpan="4">
                          {t("subtotal_txt")}:
                        </td>
                        <td align="right">{priceFormat(subTotal)}</td>
                      </tr>
                      {vatAmount > 0 && (
                        <tr>
                          <td
                            align="right"
                            width={120}
                            colSpan="4"
                            className="td-vat-fee"
                          >
                            <span className="strong">
                              {t("vat_txt")}{" "}
                              <span className="vat-txt">
                                ({t("20%_of_txt")}{" "}
                                <span className="vat-amt">
                                  {priceFormat(vatTotalAmount)}
                                </span>
                                )<span className="color-red">*</span>:
                              </span>
                            </span>
                          </td>
                          <td className="cart-prod-vat" align="right">
                            {priceFormat(vatAmount)}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td align="right" width={120} colSpan="4">
                          {t("shipping_txt")}:
                        </td>
                        <td align="right">
                          <span className="color-red">{t("free_txt")}</span>
                        </td>
                      </tr>
                      {order.promoCode && order.promoCodeDiscount > 0 && (
                        <tr>
                          <td
                            align="right"
                            width={120}
                            colSpan="4"
                            className="td-vat-fee"
                          >
                            <span className="strong">
                              {" "}
                              <i>
                                {t("promocode_discount_txt")}{" "}
                                <span className="vat-txt">
                                  {t("promo_discount_text")
                                    .replace("{discount}", order.promoCodeDiscount)
                                    .replace("{amount}", subTotal + vatAmount)}
                                </span>
                              </i>
                              <span className="colon-bold"> :</span>
                            </span>
                          </td>
                          <td align="right" className="cart-prod-vat">
                            - {priceFormat(order.promoCodeAppliedAmount)}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td align="right" width={120} colSpan="4">
                          {t("grand_total_txt")}:
                        </td>
                        <td align="right">
                          {priceFormat(order.OrderTotalWithVat)}
                        </td>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
            {order.OrderDiscount > 0 && (
              <span className="tot-ofr-applied">
                {t("order_discount_applied")
                  .replace("{discount}", order.OrderDiscount)}
              </span>
            )}
            {order.promoCodeAppliedAmount > 0 && (
              <span className="tot-ofr-applied">
                {t("first_order_discount_saved")
                  .replace("{amount}", order.promoCodeAppliedAmount)
                  .replace("{discount}", order.promoCodeDiscount)}
              </span>
            )}
          </>
        }
      />
    );
    setState({ popupView: popupResult });
  }

  function str_replace(product_name) {
    if (product_name !== "") {
      product_name = product_name.replaceAll("amp;", "&");
      product_name = product_name.replaceAll("apos;'", "'' ");
      product_name = product_name.replaceAll("quot;'", "'' ");
      return product_name;
    } else {
      return product_name;
    }
  }

  function getOrderNotes(OrderNote) {
    var note_test = OrderNote.replaceAll(" PIXHALLCSL", "");
    note_test = note_test.replaceAll("amp;", "&");
    note_test = note_test.replaceAll("apos;", "'' ");
    note_test = note_test.replaceAll("apos;'", "'' ");
    note_test = note_test.replaceAll("quot;'", "'' ");
    note_test = note_test.replaceAll("quot;", "'' ");
    note_test = note_test.replaceAll("'' '", "'' ");
    return note_test;
  }

  const handleReset = () => {
    setState({
      orders: stateRef.current.temporders,
      searchstate: false,
      searchField: "",
      searchFieldtxt: t("order_number_txt"),
      searchTextVal: "",
    });
    if (searchFieldRef.current) {
      searchFieldRef.current.selectedIndex = 1;
    }
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  };
  //Auto-Suggestions for Price Band
  const handlePriceBandChange = (e) => {
    const value = e.target.value;
    setState({ searchTextVal: value, alertPopup: false, showPopup: false });
    if (value.trim() === "") {
      setState({ suggestions: [] });
      return;
    }
    const suggestions = [
      ...new Set(
        stateRef.current.priceBands
          .filter(
            (item) => item && item.toLowerCase().includes(value.toLowerCase()),
          ),
      ),
    ];
    setState({ suggestions });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setState({ searchTextVal: value });
    const lowercasedValue = value.toLowerCase().trim();
    const sourceList =
      stateRef.current.searchField === "isFavouriteOrder"
        ? stateRef.current.tempFavouriteOrders
        : stateRef.current.temporders;
    const searchData = sourceList.filter((item) => {
      if (lowercasedValue === "orders placed") {
        return true;
      } else if (
        Number.isInteger(Number(lowercasedValue)) &&
        stateRef.current.searchFieldtxt === t("order_number_txt")
      ) {
        return item.OrderNumber.toLowerCase().includes(lowercasedValue);
      } else if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        stateRef.current.searchFieldtxt === t("account_code_txt")
      ) {
        return item.accountCode.toLowerCase().includes(lowercasedValue);
      } else if (stateRef.current.searchField === "placedBy") {
        if (!lowercasedValue) return true;
        if (!item.placedBy) return false;
        const placedByLower = item.placedBy.toLowerCase();
        // Only allow HO or Chef orders
        if (
          !placedByLower.includes("(ho account)") &&
          !placedByLower.includes("(chef account)")
        ) {
          return false;
        }
        // Extract account code before bracket
        const accountCodePart = placedByLower.split("(")[0].trim();
        return accountCodePart.includes(lowercasedValue);
      } else if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        stateRef.current.searchField === "mainDepot"
      ) {
        return (
          item.mainDepot &&
          item.mainDepot.toLowerCase().includes(lowercasedValue)
        );
      } else if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        stateRef.current.searchField === "subDepot"
      ) {
        return (
          item.subDepot && item.subDepot.toLowerCase().includes(lowercasedValue)
        );
      } else if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        stateRef.current.searchField === "OrderStatus"
      ) {
        return item.OrderStatus.toLowerCase().includes(lowercasedValue);
      } else if (
        lowercasedValue === "a" ||
        (lowercasedValue === "k" &&
          stateRef.current.searchField === "PaymentMethod")
      ) {
        return item.PaymentMethod.toLowerCase().includes(lowercasedValue);
      } else if (stateRef.current.searchField === "hasPromoPinsa") {
        if (lowercasedValue === "") {
          return true;
        }
        if (!item.hasPromoPinsa) {
          return false;
        }
        if (lowercasedValue === "all") {
          return true;
        }
        return (
          item.clientInfo &&
          item.clientInfo[0]?.Sectors &&
          item.clientInfo[0].Sectors.toLowerCase().includes(lowercasedValue)
        );
      } else if (stateRef.current.searchField === "isFavouriteOrder") {
        if (!lowercasedValue) return true;
        return item.accountCode.toLowerCase().includes(lowercasedValue);
      }
    });
    setState({ orders: searchData, searchstate: true });
  };

  const handleNoteChange = async (value) => {
    setState({ note: value.trim(), noteError: false });
  };

  const handleDateFilterChange = (filterType) => {
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    const newState = { tempDateFilterType: filterType, isFilterApplied: true };
    if (filterType === "orderDate") {
      if (
        stateRef.current.datefrom &&
        new Date(stateRef.current.datefrom) > today
      ) {
        newState.datefrom = null;
      }
      if (
        stateRef.current.dateto &&
        new Date(stateRef.current.dateto) > today
      ) {
        newState.dateto = null;
      }
    }
    setState(newState);
  };

  const filterData = () => {
    const value = stateRef.current.searchTextVal;
    const lowercasedValue = value.toLowerCase().trim();
    const sourceList =
      stateRef.current.searchField === "isFavouriteOrder"
        ? stateRef.current.tempFavouriteOrders
        : stateRef.current.temporders;
    const searchData = sourceList.filter((item) => {
      if (lowercasedValue === "orders placed") {
        return true;
      } else if (
        Number.isInteger(Number(lowercasedValue)) &&
        stateRef.current.searchFieldtxt === t("order_number_txt")
      ) {
        return item.OrderNumber.toLowerCase().includes(lowercasedValue);
      } else if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        stateRef.current.searchFieldtxt === t("account_code_txt")
      ) {
        return item.accountCode.toLowerCase().includes(lowercasedValue);
      } else if (stateRef.current.searchField === "PriceBand") {
        return (
          item.Priceband &&
          item.Priceband.toLowerCase().includes(lowercasedValue)
        );
      } else if (stateRef.current.searchField === "mainDepot") {
        return (
          item.mainDepot &&
          item.mainDepot.toLowerCase().includes(lowercasedValue)
        );
      } else if (stateRef.current.searchField === "subDepot") {
        return (
          item.subDepot && item.subDepot.toLowerCase().includes(lowercasedValue)
        );
      } else if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        stateRef.current.searchField === "OrderStatus"
      ) {
        return item.OrderStatus.toLowerCase().includes(lowercasedValue);
      } else if (
        lowercasedValue === "a" ||
        (lowercasedValue === "k" &&
          stateRef.current.searchField === "PaymentMethod")
      ) {
        return item.PaymentMethod.toLowerCase().includes(lowercasedValue);
      } else if (stateRef.current.searchField === "placedBy") {
        if (!lowercasedValue) return true;
        if (!item.placedBy) return false;
        const placedByLower = item.placedBy.toLowerCase();
        // Only allow HO or Chef orders
        if (
          !placedByLower.includes("(ho account)") &&
          !placedByLower.includes("(chef account)")
        ) {
          return false;
        }
        // Extract account code before bracket
        const accountCodePart = placedByLower.split("(")[0].trim();
        return accountCodePart.includes(lowercasedValue);
      } else if (stateRef.current.searchField === "hasPromoPinsa") {
        if (lowercasedValue === "") {
          return true;
        }
        if (!item.hasPromoPinsa) {
          return false;
        }
        if (lowercasedValue === "all") {
          return true;
        }
        return (
          item.clientInfo &&
          item.clientInfo[0]?.Sectors &&
          item.clientInfo[0].Sectors.toLowerCase().includes(lowercasedValue)
        );
      } else if (stateRef.current.searchField === "isFavouriteOrder") {
        if (!lowercasedValue) return true;
        return item.accountCode.toLowerCase().includes(lowercasedValue);
      }
    });
    setState({ orders: searchData, alertPopup: false, searchstate: true });
  };

  const alertPopupclose = () => {
    setState({ visibleAlert: false });
  };

  const handleConfirmExportToExcel = () => {
    const { orders } = stateRef.current;
    if (!orders || orders.length === 0) {
      // Show no data popup
      setState({ visibleNoDataAlert: true });
      return;
    }
    setState({ visibleAlert: true });
  };

  const handleCloseNoDataAlert = () => {
    setState({ visibleNoDataAlert: false });
  };
  // Export Records
  const handleExportToExcel = () => {
    const { orders, datefromLabel, datetoLabel, datelabel } = stateRef.current;
    const { totalOrderCount, totalOrderAmount } = orderRecordsTotal(orders);
    let dateRangeText = "";
    if (datefromLabel && datetoLabel) {
      dateRangeText = `From ${formatDate(datefromLabel)} to ${formatDate(datetoLabel)}`;
    } else {
      dateRangeText = datelabel;
    }
    const firstRowText = t("total_records_order_amount")
      .replace("{count}", totalOrderCount)
      .replace("{dateRange}", dateRangeText)
      .replace("{amount}", totalOrderAmount);
    const headers = [
      t("order#_number_txt"),
      t("account_code_txt"),
      t("account_name_txt"),
      t("email_address_txt"),
      t("price_band_txt"),
      t("ordered_date_txt"),
      t("delivery_date_txt"),
      t("payment_method_txt"),
      t("status_txt"),
      t("order_total_txt"),
    ];
    const headerStyle = {
      font: { bold: true },
      alignment: { horizontal: "left" },
    };
    const styledHeaders = headers.map((text) => ({ v: text, s: headerStyle }));
    const rows = orders.map((order) => [
      order.OrderNumber,
      order.accountCode,
      order.accountName,
      order.accountEmail,
      order.Priceband,
      moment(order.createdAt).format("DD/MM/YYYY"),
      order.DateRequired,
      order.PaymentMethod === "A"
        ? order.OrderPaid === "YES"
          ? t("paid_pay_later_txt")
          : t("pay_later_txt")
        : t("online_payment_txt"),
      order.OrderStatus,
      {
        v: priceFormat(order.OrderTotalWithVat),
        s: { alignment: { horizontal: "right" } },
      },
    ]);
    const worksheetData = [
      [
        {
          v: firstRowText,
          s: { font: { bold: true }, alignment: { horizontal: "left" } },
        },
      ],
      styledHeaders,
      ...rows,
    ];
    const columnWidths = headers.map((header, index) => {
      let maxLength = header.length;
      rows.forEach((row) => {
        maxLength = Math.max(maxLength, String(row[index]).length);
      });
      return { wch: maxLength + 2 };
    });
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);
    ws["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: headers.length - 1 },
      },
    ];
    ws["!cols"] = columnWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");
    const exportDateTime = moment().format("DD-MM-YYYY");
    const fileName = `Tugo Order Report-${exportDateTime}.xlsx`;
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    saveAs(blob, fileName);
    setState({ visibleAlert: false });
  };

  const orderRefresh = useCallback((order) => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    var numberOfAjaxCAllPending = 0;
    var timeInterval = 20000;
    var element = document.getElementById(
      "refresh_order_id" + order.OrderNumber,
    );
    element.classList.add("fa-spin");
    setState({ alertPopup: false });
    let URL =
      BaseUrl +
      "updateorderitems/" +
      order.accountCode +
      "/" +
      order.OrderNumber;
    http
      .get(URL)
      .then((response) => {
        numberOfAjaxCAllPending++;
        let responseData = [];
        responseData = response.data.data[0];
        setState((prevState) => ({
          orders: prevState.orders.map((o) =>
            o.OrderNumber === responseData.OrderNumber ? responseData : o,
          ),
          temporders: prevState.temporders.map((o) =>
            o.OrderNumber === responseData.OrderNumber ? responseData : o,
          ),
          alertPopup: false,
          alertMessage: "",
          loading: false,
        }));
        // Call filterData after state update if searchstate is true
        if (stateRef.current.searchstate) {
          filterData();
        }
        element.classList.remove("fa-spin");
        clearInterval(myInterval);
      })
      .catch((err) => {
        console.log(err);
        setState({
          alertPopup: true,
          alertMessage: t("server_busy_txt"),
        });
      });
    var myInterval = setInterval(function () {
      if (numberOfAjaxCAllPending == 0) {
        numberOfAjaxCAllPending++;
        timeInterval = "";
        setState({
          alertPopup: true,
          alertMessage: t("server_busy_txt"),
        });
      }
    }, timeInterval);
  }, []);

  function handleApplyOrderFilters() {
    setState({ trigerDateFilter: true });
  }

  function fetchRestrictedAccounts() {
    return http
      .get(BaseUrl + "admin/accountcodelist")
      .then((res) => {
        const ids = res.data?.data?.map((acc) => acc.accountCode);
        setState({ restrictedAccounts: ids || [] });
      })
      .catch((err) => {
        console.error("Failed to load restricted accounts", err);
      });
  }

  function applyOrderFilters() {
    let dateinvalid = false; //Added by K2b Sangeetha for date range error
    if (stateRef.current.dateRange !== "") {
      setState({
        isElementVisible: false,
        loading: true,
        alertPopup: false,
        isElementVisibleMobile: false,
        dateinvalid_error: false,
        datefill_error: false,
        dateFilterType: stateRef.current.tempDateFilterType,
      });
      var payload = {
        orderdays: stateRef.current.dateRange,
        datefrom: "",
        dateto: "",
        filterType: stateRef.current.tempDateFilterType,
      };
      if (stateRef.current.dateRange === "custom") {
        if (stateRef.current.datefrom && stateRef.current.dateto) {
          var dateval = new Date(stateRef.current.datefrom);
          dateval = format(dateval, "yyyy-MM-dd");
          var dateval2 = new Date(stateRef.current.dateto);
          dateval2 = format(dateval2, "yyyy-MM-dd");
          setState({
            datefromLabel: stateRef.current.datefrom,
            datetoLabel: stateRef.current.dateto,
            datefill_error: false,
          });
          payload = {
            orderdays: "",
            datefrom: dateval,
            dateto: dateval2,
            filterType: stateRef.current.tempDateFilterType,
          };
        } else {
          dateinvalid = true;
          setState({
            datefill_error: true,
            isElementVisible: true,
            loading: false,
          });
        }
      } else {
        setState({ datelabel: stateRef.current.selectedDateOption.label });
        payload = {
          orderdays: stateRef.current.dateRange,
          datefrom: "",
          dateto: "",
          filterType: stateRef.current.tempDateFilterType,
        };
        setState({
          datefromLabel: "",
          datetoLabel: "",
        });
      }
      if (!dateinvalid) {
        let URL = BaseUrl + "admin/orders";
        // Send the GET request with parameters in the 'params' property
        if (sessionStorage.getItem("authData")) {
          var loginemail = JSON.parse(
            sessionStorage.getItem("authData"),
          ).adminEmail;
        }
        http
          .post(URL, payload)
          .then((response) => {
            let responseData = [];
            const { restrictedAccounts } = stateRef.current;
            if (loginemail === "karthik@k2bsolutions.in") {
              responseData = response.data.data;
            } else {
              responseData = response.data.data.filter(
                (order) => !restrictedAccounts.includes(order.accountCode),
              );
            }
            // tempFavouriteOrders from API data
            const freshFavourites =
              stateRef.current.searchField === "isFavouriteOrder"
                ? responseData.filter((item) => item.isFavouriteOrder === true)
                : stateRef.current.tempFavouriteOrders;
            setState({
              orders: responseData,
              temporders: responseData,
              tempFavouriteOrders: freshFavourites, // update with fresh data
              loading: false,
            });
            // Call filterData after state update if searchstate is true
            if (stateRef.current.searchstate) {
              filterData();
            }
          })
          .catch((err) => {
            console.log("Error:", err); // Log the error

            setState({ loading: false });
          });
      }
    }
  }

  function clearFilterOrderSearch() {
    if (!stateRef.current.isFilterApplied) {
      setState({
        selectedDateOption: { value: "1", label: t("past_30_days_txt") },
        dateRange: 30,
        trigerDateFilter: true,
      });
    } else {
      clearTempFilterValues();
      setState({ isFilterApplied: false });
    }
  }

  function clearforOpenFilter() {
    setState({ isFilterApplied: false });
    clearTempFilterValues();
  }

  function clearTempFilterValues() {
    var currentDateLabel = "";
    if (stateRef.current.datefromLabel && stateRef.current.datetoLabel) {
      currentDateLabel = t("custom_txt");
    } else {
      currentDateLabel = stateRef.current.datelabel;
    }
    console.log(currentDateLabel);
    const selectedFilterOption = stateRef.current.rangeOptions.find(
      (range) => range.label === currentDateLabel,
    );
    var tempVal = {};
    if (selectedFilterOption && selectedFilterOption.label === t("custom_txt")) {
      tempVal = {
        datepickershow: true,
        selectedDateOption: selectedFilterOption,
        datefrom: stateRef.current.datefromLabel,
        dateto: stateRef.current.datetoLabel,
      };
    } else {
      tempVal = {
        datefrom: null,
        dateto: null,
        datepickershow: false,
        selectedDateOption: selectedFilterOption,
      };
    }
    setState(tempVal);
  }

  const handleFilterChange = (e) => {
    setState({ isFilterApplied: true, selectedDateOption: e });
    if (e.value !== "") {
      var valueDates = "";
      if (e.value == "1") {
        valueDates = 30;
        setState({
          datepickershow: false,
          datefilterlabel: t("past_30_days_txt"),
        });
      } else if (e.value == "3") {
        valueDates = 30 * 3;
        setState({
          datepickershow: false,
          datefilterlabel: t("past_90_days_txt"),
        });
      } else if (e.value == "6") {
        valueDates = 30 * 6;
        setState({
          datepickershow: false,
          datefilterlabel: t("past_180_days_txt"),
        });
      } else if (e.value == "1Year") {
        valueDates = 365;
        setState({
          datepickershow: false,
          datefilterlabel: t("past_1_year_txt"),
        });
      } else if (e.value == "custom") {
        valueDates = "custom";
        setState({ datepickershow: true, datefilterlabel: "" });
      }
      setState({ dateRange: valueDates, dateinvalid_error: false });
    }
  };

  function DateChange(value, type) {
    setState({ isFilterApplied: true });
    if (type == "from") {
      if (stateRef.current.dateto) {
        var fromVal = format(new Date(value), "yyyy-MM-dd");
        var toVal = format(new Date(stateRef.current.dateto), "yyyy-MM-dd");
        if (fromVal > toVal) {
          setState({ datefrom: value, dateto: "", dateinvalid_error: true });
          return;
        }
      }
      setState({ datefrom: value, dateinvalid_error: false });
    } else if (type == "to") {
      var dateval = new Date(stateRef.current.datefrom);
      dateval = format(dateval, "yyyy-MM-dd");
      var dateval2 = new Date(value);
      dateval2 = format(dateval2, "yyyy-MM-dd");
      if (dateval > dateval2) {
        setState({ dateto: "", dateinvalid_error: true });
      } else {
        setState({ dateto: value, dateinvalid_error: false });
      }
    }
  }
  /*added by k2bv */
  function formatDate(dateString) {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  }
  /*added by k2bv */
  /*added by K2b*/
  const handleSearchFieldChange = (event) => {
    const selectedOption = searchFieldRef.current.selectedOptions[0];
    const value = searchFieldRef.current.value;
    let textval = selectedOption ? selectedOption.innerText : "";
    if (value === "placedBy") {
      textval = t("ho/chef_account_txt");
    }
    // Clear the input value
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
    if (value === "isFavouriteOrder") {
      const filtered = stateRef.current.temporders.filter(
        (item) => item.isFavouriteOrder === true,
      );
      setState({
        searchField: value,
        searchFieldtxt: t("account_code_txt"),
        searchTextVal: "",
        orders: filtered,
        tempFavouriteOrders: filtered,
        searchstate: true,
      });
      return;
    }
    if (value === "hasPromoPinsa") {
      setState({
        searchField: value,
        searchFieldtxt: textval,
        searchTextVal: "", // default
      });
    } else {
      setState({
        searchField: value,
        searchFieldtxt: textval,
        searchTextVal: "",
      });
    }
  };

  const renderSearchInput = () => {
    const { searchTextVal } = stateRef.current;
    const searchField = searchFieldRef.current
      ? searchFieldRef.current.value
      : "";
    if (searchField === "PaymentMethod") {
      return (
        <div className="orders-dropdown">
          <select
            className="search-ord"
            ref={searchInputRef}
            onChange={handleChange}
          >
            <option value="">{t("select_txt")}</option>
            <option value="K">{t("online_payment_txt")}</option>
            <option value="A">{t("pay_later_txt")}</option>
          </select>
        </div>
      );
    } else if (searchField === "OrderStatus") {
      return (
        <div className="orders-dropdown">
          <select
            className="search-ord"
            ref={searchInputRef}
            onChange={handleChange}
          >
            <option value="">{t("select_txt")}</option>
            <option value="Orders Placed">{t("orders_placed_txt")}</option>
            <option value="New Order">{t("new_order_txt")}</option>
            <option value="Acknowledged">{t("acknowledged_txt")}</option>
            <option value="Acknl  Being Picked">{t("acknl_being_picked_txt")}</option>
            <option value="Invoiced">{t("invoiced_txt")}</option>
            <option value="Part Desp.  Inv.">{t("part_desp_inv_txt")}</option>
            <option value="Cancelled">{t("cancelled_txt")}</option>
          </select>
        </div>
      );
    } else if (searchField === "mainDepot") {
      return (
        <select
          ref={searchInputRef}
          className="search-ord"
          onChange={(e) => handleChange(e)}
        >
          <option value="">{t("select_txt")}</option>
          {stateRef.current.mainDepotList.map((item) => (
            <option key={item.mainDepot} value={item.mainDepot}>
              {item.mainDepot}
            </option>
          ))}
        </select>
      );
    } else if (searchField === "subDepot") {
      return (
        <select
          ref={searchInputRef}
          className="search-ord"
          onChange={(e) => handleChange(e)}
        >
          <option value="">{t("select_txt")}</option>
          {stateRef.current.subDepotList.map((item) => (
            <option key={item.subDepot} value={item.subDepot}>
              {item.subDepot}
            </option>
          ))}
        </select>
      );
    } else if (searchField === "PriceBand") {
      return (
        <div>
          <input
            type="text"
            ref={searchInputRef}
            onChange={handlePriceBandChange}
            placeholder={`${t("searchby_txt")} ${stateRef.current.searchFieldtxt}`}
          />
          {/* autosuggestion for priceband */}
          {stateRef.current.searchTextVal.trim() !== "" &&
            stateRef.current.suggestions.length > 0 && (
              <ul className="suggestions-list">
                {stateRef.current.suggestions.map((item, index) => (
                  <li key={index} onClick={() => handleSuggestionClick(item)}>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          {/* autosuggestion for priceband */}
        </div>
      );
    } else if (searchField === "hasPromoPinsa") {
      return (
        <select
          ref={searchInputRef}
          className="search-ord"
          onChange={(e) => handleChange(e)}
          defaultValue=""
        >
          <option value="">{t("select_txt")}</option>
          <option value="all">{t("all_txt")}</option>
          {stateRef.current.sectorList.map((item, index) => (
            <option key={item._id} value={item.MasterValue}>
              {item.MasterValue}
            </option>
          ))}
        </select>
      );
    } else if (searchField === "isFavouriteOrder") {
      return (
        <input
          type="text"
          ref={searchInputRef}
          onChange={handleChange}
          placeholder={`${t("searchby_txt")} ${stateRef.current.searchFieldtxt}`}
        />
      );
    } else {
      return (
        <input
          type="text"
          ref={searchInputRef}
          onChange={handleChange}
          placeholder={`${t("searchby_txt")} ${stateRef.current.searchFieldtxt}`}
        />
      );
    }
  };

  const handleSuggestionClick = (selectedValue) => {
    if (searchInputRef.current) {
      searchInputRef.current.value = selectedValue;
    }
    const searchData = stateRef.current.temporders.filter(
      (item) => item.Priceband == selectedValue,
    );
    setState({
      orders: searchData,
      suggestions: [],
      searchTextVal: selectedValue,
      searchstate: true,
    });
  };
  /*added by K2b */
  const orderNotelog = useCallback((order) => {
    setState({ isLoading: true });
    var loginDetails = {};
    let responseData = [];
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    let URL = BaseUrl + "admin/orderlog/" + order.OrderNumber;
    // Start loading
    setState({ isLoading: true, notesPopup: true, currentOrder: order });
    http
      .get(URL)
      .then(async (response) => {
        responseData = response.data.data;
        setState({
          isLoading: false,
          orderlogs: responseData,
          notesPopup: true,
        });
      })
      .catch((error) => {
        setState({ isLoading: false });
        console.error("Error getting status:", error);
      });
  }, []);

  const hideNotePopup = () => {
    setState({
      notesPopup: false,
      noteError: false,
      orderlogs: "",
      note: "",
    });
  };

  const updateNoteLog = () => {
    if (stateRef.current.note.trim() !== "") {
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let noteURL = BaseUrl + "admin/orderlog";
      const notepayload = {
        orderID: stateRef.current.currentOrder.OrderNumber,
        noteText: stateRef.current.note,
        createdBy: loginDetails.adminName,
      };
      setState({ isLoading: true });
      http
        .post(noteURL, notepayload)
        .then(async (response) => {
          setState({
            notesPopup: false,
            isLoading: false,
            showPopup: true,
            uploadMessage: t("order_note_submit_success_txt"),
          });
        })
        .catch((error) => {
          setState({ isLoading: false });
          console.error("Error submitting note:", error);
        });
    } else {
      setState({ noteError: true });
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    // restrictedAccounts is populated.
    fetchRestrictedAccounts().finally(() => {
      getAllOrders();
    });
    getPriceBands();
    fetchSectors();
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (state.trigerDateFilter === true) {
      applyOrderFilters();
      setState({ trigerDateFilter: false });
    }
  }, [state.trigerDateFilter]);

  if (sessionStorage.getItem("authData")) {
    var loginEmail = JSON.parse(sessionStorage.getItem("authData")).adminEmail;
  }

  const columns = useMemo(
    () => [
      {
        name: t("order#_number_txt"),
        selector: (row) => row.OrderNumber,
        sortable: true,
      },
      {
        name: t("account_code_txt"),
        selector: (row) => row.accountCode,
        sortable: true,
      },
      {
        name: t("payment_method_txt"),
        selector: (row) =>
          row.PaymentMethod === "A"
            ? row.OrderPaid === "YES"
              ? t("paid_pay_later_txt")
              : t("pay_later_txt")
            : t("online_payment_txt"),
        sortable: true,
      },
      {
        name: t("order_exl_total_txt"),
        selector: (row) => priceFormat(row.OrderTotal),
        sortable: true,
        sortFunction: (a, b) => {
          const totalA = parseFloat(a.OrderTotal) || 0;
          const totalB = parseFloat(b.OrderTotal) || 0;
          return totalA - totalB;
        },
      },
      {
        name: t("ordered_date_txt"),
        selector: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
        sortable: false,
      },
      {
        name: t("delivery_date_txt"),
        selector: (row) => row.DateRequired,
        sortable: true,
        sortFunction: (a, b) => {
          const parseDate = (dateStr) => {
            const [day, month, year] = dateStr.split("/").map(Number);
            return new Date(year, month - 1, day);
          };
          const dateA = parseDate(a.DateRequired);
          const dateB = parseDate(b.DateRequired);
          return dateA - dateB;
        },
      },
      {
        name: t("status_txt"),
        selector: (row) => row.OrderStatus,
        sortable: true,
      },
      {
        name: t("actions_txt"),
        selector: (row, index) => (
          <div className="order-action-tbl">
            {canAction("manage_orders", "view") && (
              <a
                className="title-tooltip title-up button"
                data-title={t("view_details_txt")}
                style={{ color: "white" }}
                onClick={() => getOrderaccountdetails(row.accountCode, row)}
              >
                <i className="fa fa-eye" aria-hidden="true"></i>
              </a>
            )}
            {canAction("manage_orders", "logs") && (
              <a
                className="button title-tooltip title-up"
                data-title={t("order_note_log_txt")}
                onClick={() => orderNotelog(row)}
              >
                <i className="fa fa-history"></i>
              </a>
            )}
            {canAction("manage_orders", "refresh") && (
              <a
                className="refresh-btn title-tooltip title-up"
                data-title={t("updated_status_of_order_txt")}
                onClick={() => orderRefresh(row)}
              >
                <i
                  className="fa fa-refresh"
                  id={"refresh_order_id" + row.OrderNumber}
                  aria-hidden="true"
                ></i>{" "}
              </a>
            )}
          </div>
        ),
        sortable: false,
      },
    ],
    [getOrderaccountdetails, orderNotelog, orderRefresh],
  );

  var datelabel = "";
  var dateValue = "";
  if (state.dateRange === "1") {
    datelabel = t("past_30_days_txt");
    dateValue = "1";
  } else if (state.dateRange === "3") {
    datelabel = t("past_90_days_txt");
    dateValue = "3";
  } else if (state.dateRange === "6") {
    datelabel = t("past_180_days_txt");
    dateValue = "6";
  } else if (state.dateRange === "365") {
    datelabel = t("past_1_year_txt");
    dateValue = "1Year";
  } else if (state.dateRange === "custom") {
    datelabel = t("custom_txt");
    dateValue = "custom";
  } else if (state.dateRange === "") {
    datelabel = t("past_30_days_txt");
    dateValue = "1";
  }

  const nodatacomponent =
    state.searchstate === false ? (
      state.datefromLabel && state.datetoLabel ? (
        <div className="no-records-found">
          {t("no_order_records_date_range")
            .replace("{from}", formatDate(state.datefromLabel))
            .replace("{to}", formatDate(state.datetoLabel))}
        </div>
      ) : (
        <div className="no-records-found">
          {t("no_order_records_date").replace(
            "{date}",
            state.datelabel
          )}
        </div>
      )
    ) : (
      <div className="no-records-found">
        {t("no_orders_matching_keyword")}
      </div>
    );

  const currentOrderTotals =
    state.orders.length > 0
      ? orderRecordsTotal(state.orders)
      : { totalOrderCount: 0, totalOrderAmount: "0.00" };

  return (
    <>
      {state.alertPopup === true && (
        <CommonAlert title={t("alert_txt")} message={state.alertMessage} />
      )}
      <section className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <div className="cart-block">
            <div className="container">
              <div className="flex-title">
                <h1 className="checkout-title">{t("order_txt")}</h1>
                <div className="prod-import-btn odr-expo-btn">
                  {canAction("manage_orders", "kitchen") && (
                    <a href="/kitchen-orders">
                      <button
                        type="button"
                        title={t("view_kitchen_orders_txt")}
                        className="export-btn button title-tooltip title-left"
                      >
                        {t("kitchen_orders_txt")}
                      </button>
                    </a>
                  )}
                  {/* Export Button */}
                  <>
                    {canAction("manage_orders", "export") && (
                      <a
                        data-title={t("export_filtered_records")}
                        className="export-btn button title-tooltip title-left"
                        onClick={handleConfirmExportToExcel}
                      >
                        {t("export_btn_txt")}
                      </a>
                    )}
                  </>
                </div>
                {/* Export Button */}
              </div>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders orders-search-bx">
                  <div className="orders-drop-left">
                    <div className="orders-dropdown">
                      <select
                        className="handle-srch"
                        ref={searchFieldRef}
                        onChange={handleSearchFieldChange}
                      >
                        <option value="" disabled>
                          {t("searchby_field_txt")}
                        </option>
                        <option value="OrderNumber">{t("order_number_txt")}</option>
                        <option value="OrderStatus">{t("order_status_txt")}</option>
                        <option value="accountCode">{t("account_code_txt")}</option>
                        <option value="PaymentMethod">{t("payment_method_txt")}</option>
                        <option value="PriceBand">{t("price_band_txt")}</option>
                        <option value="mainDepot">{t("main_depot_txt")}</option>
                        <option value="subDepot">{t("local_depot_txt")}</option>
                        <option value="placedBy">
                          {t("orderby_ho/chef_account_txt")}
                        </option>
                        <option value="hasPromoPinsa">
                          {t("sector_based_promo_offer_txt")}
                        </option>
                        <option value="isFavouriteOrder">
                          {t("order_via_favo_txt")}
                        </option>
                      </select>
                    </div>
                    <div className="table-search-reset">
                      <div className="table-search">
                        {renderSearchInput()}
                      </div>
                      <button
                        className="submitbtn button search-ord-btn"
                        onClick={filterData}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                      <button
                        className="resetbtn"
                        type="reset"
                        onClick={handleReset}
                      >
                        {t("reset_txt")}
                      </button>
                    </div>
                  </div>
                  <div className="select-drop" ref={dropdownRef}>
                    <a
                      className={
                        state.isElementVisible == true
                          ? "filter-btn button active"
                          : "filter-btn button"
                      }
                      onClick={openFilter}
                    >
                      {t("more_filter_txt")}{" "}
                      <span className="filter-icon">
                        <i className="fa fa-sliders" aria-hidden="true"></i>
                      </span>
                    </a>
                    <div
                      className={
                        state.isElementVisible == true
                          ? "filter-bx show"
                          : "filter-bx"
                      }
                    >
                      <div className="filter-date-range">
                        <div className="product-export-type mb-2">
                          <h5>{t("filteredby_txt")}</h5>
                          <div className="custom_check-box flex-row gap-1">
                            <div className="radio-box">
                              <input
                                type="radio"
                                id="grouped"
                                name="dateFilterType"
                                value="orderDate"
                                checked={
                                  state.tempDateFilterType === "orderDate"
                                }
                                onChange={() =>
                                  handleDateFilterChange("orderDate")
                                }
                              />
                              <label htmlFor="grouped">{t("ordered_date_txt")}</label>
                            </div>
                            <div className="radio-box">
                              <input
                                type="radio"
                                id="column"
                                name="dateFilterType"
                                value="deliveryDate"
                                checked={
                                  state.tempDateFilterType === "deliveryDate"
                                }
                                onChange={() =>
                                  handleDateFilterChange("deliveryDate")
                                }
                              />
                              <label htmlFor="column">{t("delivery_date_txt")}</label>
                            </div>
                          </div>
                        </div>
                        <div className="fltr-dt-wrap">
                          <label>
                            {t("daterange_txt")} (
                            {state.tempDateFilterType === "orderDate"
                              ? t("ordered_date_txt")
                              : t("delivery_date_txt")}
                            ):
                          </label>
                          <Select
                            value={state.selectedDateOption}
                            options={state.rangeOptions}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 6,
                              height: 40,
                              colors: {
                                ...theme.colors,
                                primary25: "#e0dedb",
                                primary: "#ec2f45",
                              },
                            })}
                            onChange={handleFilterChange}
                          />
                        </div>
                      </div>
                      <div
                        className={
                          state.datepickershow == true
                            ? "fltr-dt-range show"
                            : "fltr-dt-range"
                        }
                      >
                        <div className="fltr--date">
                          <span>{t("from_txt")}</span>
                          <DatePicker
                            selected={state.datefrom}
                            placeholderText={t("select_date_txt")}
                            showDisabledMonthNavigation
                            dateFormat="dd/MM/yyyy"
                            disablePast={true}
                            maxDate={
                              state.tempDateFilterType === "deliveryDate"
                                ? new Date(
                                    new Date().setMonth(
                                      new Date().getMonth() + 1,
                                    ),
                                  )
                                : new Date()
                            }
                            onChange={(date) => DateChange(date, "from")}
                          />
                          <span className="date-icon">
                            <i
                              className="fa fa-calendar"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                        <div className="fltr--date">
                          <span>{t("to_txt")}</span>
                          <DatePicker
                            selected={state.dateto}
                            placeholderText={t("select_date_txt")}
                            showDisabledMonthNavigation
                            dateFormat="dd/MM/yyyy"
                            disablePast={true}
                            maxDate={
                              state.tempDateFilterType === "deliveryDate"
                                ? new Date(
                                    new Date().setMonth(
                                      new Date().getMonth() + 1,
                                    ),
                                  )
                                : new Date()
                            }
                            onChange={(date) => DateChange(date, "to")}
                          />
                          <span className="date-icon">
                            <i
                              className="fa fa-calendar"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                      </div>
                      {state.dateinvalid_error === true && (
                        <span className="color-red">
                          {t("invalid_start_end_date_txt")}
                        </span>
                      )}
                      {state.datefill_error === true && (
                        <span className="color-red">
                          {t("fill_from_to_date_txt")}
                        </span>
                      )}
                      <div className="filter-btns">
                        <button
                          type="button"
                          className="button clear-btn"
                          onClick={() => clearFilterOrderSearch()}
                        >
                          {t("clear_txt")}
                        </button>
                        <button
                          type="button"
                          className="button apply-btn"
                          onClick={() => handleApplyOrderFilters()}
                        >
                          {t("apply_txt")}{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {state.dateFilterType && state.loading === false && (
                  <div className="filter-field-wrap flex-row align-center gap-1">
                    <div>
                      <strong>{t("filteredby_txt")}</strong>
                    </div>
                    <div className="filter-show-bx">
                      <span className="filters">
                        {state.dateFilterType === "orderDate"
                          ? t("ordered_date_txt")
                          : t("delivery_date_txt")}
                      </span>
                    </div>
                  </div>
                )}
                {state.orders.length > 0 && state.loading === false && (
                  <p className="admin-order account-total-records">
                    {t("total_record_txt")}{" "}
                    {state.orders.length > 0
                      ? currentOrderTotals.totalOrderCount
                      : ""}
                    {state.datefromLabel && state.datetoLabel ? (
                      <span>
                        {" "}
                        ({t("from_txt")} {formatDate(state.datefromLabel)} {t("to_txt")}{" "}
                        {formatDate(state.datetoLabel)})
                      </span>
                    ) :
                    state.datelabel ? (
                      ` (${state.datelabel})`
                    ) : (
                      ""
                    )}
                    {state.orders.length > 0 && state.loading === false && (
                      <span className="ord-TotalAmt">
                        {""} {t("total_order_amount_incl_txt")}:{" "}
                        {state.orders.length > 0
                          ? currentOrderTotals.totalOrderAmount
                          : "0.00"}{" "}
                      </span>
                    )}
                  </p>
                )}
                <div className="checkout-table table_overflow orders-table">
                  <DataTable
                    columns={columns}
                    noDataComponent={nodatacomponent}
                    data={state.orders}
                    customStyles={CUSTOM_TABLE_STYLES}
                    pagination
                    paginationPerPage={25}
                    progressPending={state.loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={PAGINATION_COMPONENT_OPTIONS}
                  />
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
        {state.popupView}
      </section>
      {/* Loader & Popup START */}
      <div className="common">
        {/* <Alert extractId="success" customContent="Cart Added Success" /> */}
      </div>
      {/* Loader & Poupp END */}
      {state.notesPopup && (
        <Popup
          extClass="info-poup show"
          closebtn={
            <>
              <span onClick={hideNotePopup} className="close"></span>
            </>
          }
          headMoreTxt={
            <>
              <div className="order-top">
                <h4>
                  <span>
                    {t("notes_for_order_txt")} - {state.currentOrder.OrderNumber}
                  </span>
                </h4>
              </div>
            </>
          }
          bodyMoreTxt={
            <>
              <div className="bottom vendor-details ordernotes-log">
                <div className="order-notes">
                  <div className="input-field">
                    <label for="note-label">{t("enter_your_note_txt")}</label>
                    <textarea
                      name="note"
                      onChange={(e) => handleNoteChange(e.target.value)}
                    ></textarea>
                    {state.noteError && (
                      <div className="err-msg">{t("update_note_txt")}</div>
                    )}
                  </div>
                </div>
                <div className="alert-buttons btn-field btn-center">
                  <button
                    onClick={updateNoteLog}
                    className="popup-alert-btn button"
                  >
                    {t("submit_txt")}
                  </button>
                  <button
                    onClick={hideNotePopup}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </button>
                </div>
                {state.isLoading ? (
                  <div className="loading-buffer"></div>
                ) : (
                  <div className="order-notes-log">
                    {state.orderlogs &&
                      state.orderlogs.length > 0 &&
                      state.orderlogs.map((ord_item) => {
                        return (
                          <div className="info-item">
                            <div className="info-innr">
                              <p>
                                <span className="labeltxt">Date: </span>
                                {dateformatwithuktime(ord_item.createdAt)}
                              </p>
                              <p>
                                <span className="labeltxt log-reason">
                                  {t("note_txt")}{" "}
                                </span>
                                {ord_item.noteText}
                              </p>
                              <p>
                                <span className="labeltxt log-reason">
                                  {t("created_by_txt")}:{" "}
                                </span>
                                {ord_item.createdBy}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>
            </>
          }
        />
      )}
      {state.showPopup && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{state.uploadMessage}</p>

                <div className="alert-buttons">
                  <button
                    onClick={closePopup}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {state.visibleAlert === true && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("confirm_export_order_report_txt")}</p>
                <div className="alert-buttons">
                  <a
                    onClick={() => handleExportToExcel()}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    onClick={() => alertPopupclose()}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {state.visibleNoDataAlert && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("no_records_for_export_txt")}</p>
                <div className="alert-buttons">
                  <a
                    onClick={handleCloseNoDataAlert}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Orders;
